module.exports = __webpack_public_path__ + "img/bg-img-three.6971b004.png";